import React, { useState } from 'react'

import { Comment } from 'types/social-account';
import CommentText from './CommentText';
import CommentMeta from './CommentMeta';
import CommentReplies from './CommentReplies';

interface SocialCommentProps {
    comment: Comment;
    isReply?: boolean;
    onReply: (comment: Comment) => void
    onDelete: (comment: Comment, reset?: () => void) => void
    onReplyPrivately: (comment: Comment) => void
}


const SocialPostComment = ({ comment, isReply = false, onReply, onDelete, onReplyPrivately }: SocialCommentProps) => {
    const [showReplies, setShowReplies] = useState(false);

    const replies = comment.replies?.data ?? [];

    return (
        <div className={`comment ${isReply ? "reply" : ""}`}>

            <div className="comment-body">
                <CommentText
                    username={comment.from?.username}
                    text={comment.text}
                />

                <CommentMeta
                    likes={comment.like_count}
                    repliesCount={replies.length}
                    onReply={() => onReply(comment)}
                    onReplyPrivately={() => onReplyPrivately(comment)}
                    onDelete={(reset) => onDelete(comment, reset)}
                    timestamp={comment.timestamp}
                />

                {replies.length > 0 && !showReplies && (
                    <button
                        className="view-replies"
                        onClick={() => setShowReplies(true)}
                    >
                        View replies ({replies.length})
                    </button>
                )}

                {showReplies && <CommentReplies onDelete={onDelete} onReply={onReply} onReplyPrivately={onReplyPrivately} replies={replies} />}
            </div>
        </div>
    );
};



export default SocialPostComment
